import Vue from 'vue'
import Router from 'vue-router'
import { store } from '@/store'
import * as _ from 'lodash'
import Authorization from '@/providers/Authorization'

import routerAgency from '@/router/routerAgency'
import routerCompany from '@/router/routerCompany'
import routerEquipment from '@/router/routerEquipment'
import routerExemption from '@/router/routerExemption'
import routerHelp from '@/router/routerHelp'
import routerIntro from '@/router/routerIntro'
import routerProfile from '@/router/routerProfile'
import routerProject from '@/router/routerProject'
import routerRegistration from '@/router/routerRegistration'
import routerRental from '@/router/routerRental'
import routerSite from '@/router/routerSite'
import routerUser from '@/router/routerUser'
import routerUserLog from '@/router/routerUserLog'
import routerAudit from '@/router/routerAudit'

Vue.use(Router)

/*
 * To define breadcrumbs for a route:
 * - meta: {crumbs: []} gives a default link back to the dashboard
 * - add additional crumbs as needed for deeper navigation
 * - omit if no crumbs are needed
 */

const router = new Router(
    {
        mode: 'history', // NB: this is important to allow either Yii or Vue to handle the same URL routes
        scrollBehavior (to, from, savedPosition) {
            return { x: 0, y: 0 }
        },
        routes: [
            {
                name: 'home',
                path: '/',
                alias: '/site/index',
                component: require('@/pages/Home').default,
                meta: { help: 'HOME' } // this gets special treatment in HelpPane
            },
            {
                name: 'twofa',
                path: '/2fa',
                component: require('@/pages/HomePublic').default,
                props: () => ({
                    twofa: true,
                }),
                meta: {}
            },
            {
                // for use with Cypress tests only
                path: '/logout',
                component: require('@/pages/UserLogout').default,
            },
            ...routerAgency,
            ...routerAudit,
            ...routerCompany,
            ...routerEquipment,
            ...routerExemption,
            ...routerHelp,
            ...routerIntro,
            ...routerProfile,
            ...routerProject,
            ...routerRegistration,
            ...routerRental,
            ...routerSite,
            ...routerUser,
            ...routerUserLog,
            /**
             * User (non-admin) routes
             */
            {
                path: '/messages',
                component: require('@/pages/MessageView').default,
                meta: {
                    crumbs: []
                }
            },
            {
                path: '/notifications',
                component: require('@/pages/NotificationView').default,
                meta: {
                    crumbs: []
                }
            },
            {
                path: '/notifications/admin',
                component: require('@/pages/NotificationAdmin').default,
                meta: {
                    crumbs: []
                }
            },
            {
                path: '/group-email',
                component: require('@/pages/GroupEmail.vue').default,
                meta: {
                    crumbs: [],
                    security: (auth) => auth.isAdminPromise()
                }
            },
            {
                path: '/notifications/custom',
                component: require('@/pages/NotificationCustom').default,
                meta: {
                    back: {label: 'Notifications', to: '/notifications'},
                    security: (auth) => auth.isAdminPromise()
                }
            },
            {
                path: '/invitations',
                component: require('@/pages/InvitationList').default,
                meta: {
                    crumbs: []
                }
            },
            {
                path: '/programadmin/invite',
                component: require('@/pages/ProgramAdminInvite').default,
                meta: {
                    crumbs: [],
                    security: (auth) => auth.isAdminPromise()
                }
            },
            {
                path: '/projectmanager/invite',
                component: require('@/pages/ProjectManagerInvite').default,
                meta: {
                    crumbs: [],
                    security: (auth) => auth.isProgramAdminOrAdminPromise()
                }
            },
            {
                path: '/ownersrepresentative/invite',
                component: require('@/pages/OwnersRepresentativeInvite').default,
                meta: {
                    crumbs: [],
                    security: (auth) => auth.isProgramAdminOrAdminPromise()
                }
            },
            {
                path: '/auditor/invite',
                component: require('@/pages/AuditorInvite').default,
                meta: {
                    crumbs: [],
                    security: (auth) => auth.isProgramAdminOrAdminPromise()
                }
            },
            {
                path: '/equipmentowner/invite',
                component: require('@/pages/EquipmentOwnerInvite').default,
                meta: {
                    crumbs: [],
                }
            },
            {
                path: '/support',
                component: require('@/pages/ContactSupport').default,
                meta: {
                    crumbs: [],
                }
            },
            {
                path: '*',
                component: require('@/pages/NotFound').default,
            },
        ],
    }
)

// navigation guard - check authorization and render breadcrumbs
router.beforeEach(async (to, from, next) => {
    store.commit('initStore')// TEMP? prevent being kicked out in development on auto refresh

    // perform substitutions in breadcrumb URLs/labels

    // Breadcrumbs.renderCrumbs(to)

    // check for security rules

    let allow = true

    if (_.isFunction(to.meta.security)) {
        // set up the auth service with required params
        Authorization.to = to
        Authorization.from = from
        Authorization.next = next
        // TODO: spinning wait cursor?
        // call security function defined by route
        allow = await to.meta.security(Authorization)
            .catch(() => false)
    }

    if (!allow) {
        Authorization.authError('Unauthorized')
    } else {
        next()
    }
})

export default router
